// 邮箱验证弹窗
import { isApiIgnoreError } from '@/utils/sentryIgnoreErrors'
import { useLocalStorageState } from '@umijs/hooks'
import { Button, Col, Form, Input, message, Modal, Row } from 'antd'
import Countdown from 'antd/lib/statistic/Countdown'
import { inject, observer } from 'mobx-react'
import React, { useCallback, useMemo, useState } from 'react'
import { Config } from '../../utils/config'

function VerifyEmailModal(props: any) {
  const { userStore } = props
  const [form] = Form.useForm()
  const [userIsConfirm, setUserIsConfirm] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isSended, setIsSended] = useState(false)
  const [countdownDone, setCountdownDone] = useState(false)

  const [countdownTime, setCountdownTime] = useLocalStorageState('VerifyEmailModal_countdownTime', 0)

  const visible = userStore.isUserNeedVerifyEmail

  const buttonDislable = useMemo(() => loading && isSended && !countdownDone, [loading, isSended, countdownDone])

  // const { email } = userStore.userInfo;

  // 发送验证
  const onSendVerifyEmailClick = useCallback(() => {
    setLoading(true)
    userStore
      .requestSendVerifyCode()
      .then(() => {
        // 提示
        message.success('Code sent successfully!')
        setIsSended(true)
        setCountdownTime(Date.now() + Config.User.VerifyEmailCodeTime)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [userStore])

  // 验证邮箱
  const onVerifyEmailClick = useCallback(() => {
    new Promise((re, rj) => {
      form
        .validateFields()
        .then((values) => {
          re(values.verifyCode)
        })
        .catch((errorInfo) => {
          /*
       errorInfo:
         {
           values: {
             username: 'username',
             password: 'password',
           },
           errorFields: [
             { password: ['username'], errors: ['Please input your Password!'] },
           ],
           outOfDate: false,
         }
       */
        })
    })
      .then((verifyCode) => {
        setLoading(true)
        return userStore.requestEmailVerifyCode(verifyCode)
      })
      .then(() => {
        // 提示
        message.success('Verified successfully!')
      })
      // .then(() => {
      //   // 获取免费号码
      //   return userStore.requestFreeNumber().catch(err => {
      //     message.error(err.message);
      //   });
      // })
      // .then(() => {
      //   // 更新用户号码
      //   userStore.requestUserPhones();
      // })
      .catch((err) => {
        // 忽略部分业务报错
        if (isApiIgnoreError(err?.message)) {
          console.error(err)
          return
        }

        return Promise.reject(err)
      })
      .finally(() => {
        // 更新用户资料
        userStore.requestUserInfo()
        setLoading(false)
      })
  }, [userStore, form])

  // 自动发送一条验证码
  // useEffect(() => {
  //   if (visible === true) {
  //     onSendVerifyEmailClick();
  //   }
  // }, [visible])

  const onUserConfirmClick = useCallback(() => {
    onSendVerifyEmailClick()
    setUserIsConfirm(true)
  }, [])

  const onCountdownFinish = useCallback(() => {
    setCountdownTime(0)
    setCountdownDone(true)
  }, [])

  const canTrySendEmailVCode = useMemo(() => {
    return countdownTime === 0
  }, [countdownTime])

  const showUserConfirm = useMemo(() => {
    const t = new Date().getTime()
    return userIsConfirm === false && isSended === false && t > countdownTime
  }, [userIsConfirm, countdownTime])

  return (
    <Modal visible={visible} footer={null} closable={false}>
      <Row>
        <Col>
          <h2>
            <strong>Verify Your Email Address</strong>
          </h2>
        </Col>
        <Col>
          <div style={{ padding: '12px 0 16px 0' }}>
            Your email address has not been verified.
            {/* We've sent the verfication code to your email address
              <span style={{ fontWeight: "bold", fontSize: '16px' }}> {email}</span>. */}
            &nbsp; Please click{' '}
            <span className={`${showUserConfirm ? 'font-bold' : ''}`}> Get the verification code </span>
            and
            <span className={`${showUserConfirm ? '' : 'font-bold'}`}> Enter the verification code here</span>.
          </div>
        </Col>
      </Row>
      <br />

      {showUserConfirm ? (
        <Row justify="center">
          <Col>
            <Button type="primary" size="large" onClick={onUserConfirmClick}>
              Get the verification code
            </Button>
          </Col>
        </Row>
      ) : (
        <Form form={form}>
          <Form.Item name="verifyCode" rules={[{ required: true, message: 'verify code is required!' }]}>
            <Input maxLength={6} placeholder="Please Enter the verification code" allowClear />
          </Form.Item>

          <Row justify="space-between">
            <Col>
              <a
                style={
                  canTrySendEmailVCode
                    ? {
                        color: '#3ECF8E',
                        opacity: '1',
                        pointerEvents: 'initial',
                      }
                    : {
                        color: '#999999',
                        opacity: '1',
                        pointerEvents: 'none',
                      }
                }
                onClick={onSendVerifyEmailClick}
              >
                {isSended ? 'Resend the verification code' : 'Get the verification code'}
              </a>
              <Countdown
                style={{
                  display: 'inline-block',
                  marginLeft: '10px',
                  opacity: countdownTime === 0 ? '0' : '1',
                }}
                valueStyle={{ fontSize: '14px' }}
                value={countdownTime}
                format="s"
                suffix="s"
                onFinish={onCountdownFinish}
              />
            </Col>
            <Col>
              <Button loading={loading} type="primary" onClick={onVerifyEmailClick} disabled={buttonDislable}>
                Confirm
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Modal>
  )
}

export default inject('userStore')(observer(VerifyEmailModal))
